import { Component, Input, OnInit } from "@angular/core";
import { OrderEs } from "@edp-models/ES/es-order.model";

@Component({
    selector: "edp-es-order-steps",
    templateUrl: "./edp-es-order-steps.component.html",
    styleUrls: ["./edp-es-order-steps.component.scss"],
})
export class EdpEsOrderStepsComponent implements OnInit {
    @Input() order: OrderEs;
    public indexActive: number;

    constructor() {}

    ngOnInit(): void {
        this.indexActive = this.order.indexStepActive;
    }
}
